<template>
  <div>
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <!-- Card -->
        <div class="card mt-5">
          <!-- Header -->
          <div class="card-header border-bottom-0 pb-0">
            <div class="row align-items-center">
              <div class="col">
                <!-- Title -->
                <h4 class="card-header-title mb-0">Mitra Enrollment</h4>
              </div>
            </div>
          </div>

          <div class="p-4">
            <!-- Period Selection -->
            <div class="row mb-4">
              <div class="col-lg-4">
                <label class="form-label">Period :</label>
                <v-select
                  v-model="selectedPeriod"
                  :options="periodOptions"
                  :reduce="option => option.value"
                  label="label"
                  placeholder="Silakan pilih"
                  :clearable="false"
                  :loading="periodsLoading"
                >
                </v-select>
              </div>
            </div>

            <!-- History and This Year Section -->
            <div class="row mb-4">
              <!-- History Section -->
              <div class="col-md-6">
                <h5 class="mb-3">History</h5>
                <div class="progress mb-2" style="height: 25px;">
                  <div 
                    class="progress-bar bg-primary" 
                    role="progressbar" 
                    :style="`width: ${summary.history.percentage}%;`" 
                    :aria-valuenow="summary.history.percentage" 
                    aria-valuemin="0" 
                    aria-valuemax="100"
                  >
                    {{ summary.history.percentage }}%
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-warning">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-target"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Plan</p>
                        <h3 class="mb-0">{{ summary.history.submitted }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-teal">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check-circle"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Approved</p>
                        <h3 class="mb-0">{{ summary.history.approved }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-success">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Completed</p>
                        <h3 class="mb-0">{{ summary.history.completed }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- This Year Section -->
              <div class="col-md-6">
                <h5 class="mb-3">This Year</h5>
                <div class="progress mb-2" style="height: 25px;">
                  <div 
                    class="progress-bar bg-success" 
                    role="progressbar" 
                    :style="`width: ${summary.this_year.percentage}%;`" 
                    :aria-valuenow="summary.this_year.percentage" 
                    aria-valuemin="0" 
                    aria-valuemax="100"
                  >
                    {{ summary.this_year.percentage }}%
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-warning">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-target"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Plan</p>
                        <h3 class="mb-0">{{ summary.this_year.submitted }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-teal">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check-circle"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Approved</p>
                        <h3 class="mb-0">{{ summary.this_year.approved }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <div class="status-card bg-success">
                      <div class="d-flex align-items-center justify-content-center mb-2">
                        <div class="status-icon">
                          <i class="fe fe-check"></i>
                        </div>
                      </div>
                      <div class="text-center text-white">
                        <p class="mb-1">Completed</p>
                        <h3 class="mb-0">{{ summary.this_year.completed }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- All Course Section -->
          <div class="card-body pt-2">
            <!-- Filter Bar -->
            <div class="row align-items-center mb-4">
              <div class="col-md-2">
                <h6 class="mb-0 font-weight-bold">All Courses</h6>
              </div>
              <div class="col-md-10">
                <div class="d-flex justify-content-end align-items-center gap-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-info"
                    :disabled="isDownloadingGlobalTemplate"
                    @click="downloadGlobalTemplate">
                    <span v-if="isDownloadingGlobalTemplate" class="spinner-border spinner-border-sm me-1"></span>
                    <i v-else class="fe fe-download me-1"></i>
                    Download Template
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-success"
                    :disabled="isUploadingGlobalTemplate"
                    @click="triggerGlobalUpload">
                    <span v-if="isUploadingGlobalTemplate" class="spinner-border spinner-border-sm me-1"></span>
                    <i v-else class="fe fe-upload me-1"></i>
                    Upload Excel
                  </button>
                  <input
                    ref="globalEnrollmentFileInput"
                    type="file"
                    class="d-none"
                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    @change="handleGlobalEnrollmentFileChange" />
                  <div style="width: 250px;">
                    <input
                      type="text"
                      v-model="filters.search"
                      class="form-control form-control-sm"
                      placeholder="Search Training..." />
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger position-relative"
                    @click="showFilterModal">
                    <span class="fe fe-sliders"></span> Filter
                    <span
                      v-if="activeFiltersCount > 0"
                      class="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill"
                      style="font-size: 0.65rem; padding: 0.2rem 0.4rem;">
                      {{ activeFiltersCount }}
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div v-if="activeFiltersCount > 0" class="mb-3">
              <div class="d-flex flex-wrap align-items-center gap-2">
                <small class="text-muted">Active Filters:</small>
                <span v-if="filters.status" class="badge bg-light text-dark border">
                  Status: {{ statusFilterLabel }}
                  <button type="button" class="btn-close btn-close-sm ms-1" @click="clearSingleFilter('status')" style="font-size: 0.6rem; padding: 0.1rem;"></button>
                </span>
                <span v-if="filters.approval_step" class="badge bg-light text-dark border">
                  Approval: {{ approvalStepLabel }}
                  <button type="button" class="btn-close btn-close-sm ms-1" @click="clearSingleFilter('approval_step')" style="font-size: 0.6rem; padding: 0.1rem;"></button>
                </span>
                <span v-if="filters.course_type" class="badge bg-light text-dark border">
                  Course Type: {{ courseTypeLabel }}
                  <button type="button" class="btn-close btn-close-sm ms-1" @click="clearSingleFilter('course_type')" style="font-size: 0.6rem; padding: 0.1rem;"></button>
                </span>
                <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-2" @click="clearAllFilters">
                  Clear All
                </button>
              </div>
            </div>

            <!-- Loading State -->
            <div v-if="isLoading" class="text-center py-5">
              <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <p class="mt-2 text-muted">Loading training data...</p>
            </div>

            <!-- Empty State -->
            <div v-else-if="paginatedCourses.length === 0" class="text-center py-5">
              <i class="fe fe-inbox" style="font-size: 3rem; color: #dee2e6;"></i>
              <p class="mt-3 text-muted">No training courses found</p>
            </div>

            <!-- Cards Grid -->
            <div v-else class="row">
              <div class="col-lg-3 col-md-6 col-sm-12 mb-4" v-for="course in paginatedCourses" :key="course.id">
                <div class="card h-100 shadow-sm border course-card" @click="viewCourseDetail(course)" style="cursor: pointer;">
                  <!-- Card Image/Thumbnail -->
                  <div class="position-relative">
                    <img 
                      :src="course.cover_image_path ? `${imageBaseUrl}/attachments/${course.cover_image_path}` : 'https://dummyimage.com/300x200/FAFAFA/000000&text=Course'" 
                      :alt="course.title"
                      class="card-img-top"
                      style="height: 180px; object-fit: cover;"
                      @error="handleImageError">
                    
                    <!-- Status Badge -->
                    <div class="position-absolute d-flex flex-column gap-1" style="top: 8px; left: 8px;">
                      <span :class="getStatusBadgeClass(course.submission_status)">
                        {{ course.submission_status }}
                      </span>
                      <span v-if="course.quota_status" class="badge bg-danger">
                        {{ course.quota_status }}
                      </span>
                    </div>

                    <!-- Bookmark Icon (Top Right) -->
                    <div class="position-absolute" style="top: 8px; right: 8px;">
                      <div class="bg-white rounded shadow-sm p-1" style="display: flex; align-items: center; justify-content: center;">
                        <img 
                          :src="`${imageBaseUrl}/attachments/${course.provider_logo_path}`" 
                          :alt="course.provider_name"
                          style="height: 16px; object-fit: cover;"
                          @error="handleImageProviderError">
                      </div>
                    </div>
                  </div>
                  
                  <!-- Card Body -->
                  <div class="card-body p-3">
                    <!-- Badges Row -->
                    <div class="mb-2 d-flex flex-wrap gap-1">
                      <span class="badge-icon bg-danger-soft text-danger">
                        <i :class="getTrainingTypeIcon(course.training_type)" style="font-size: 10px;"></i>
                      </span>
                      <span class="badge-custom bg-warning-soft text-warning">
                        {{ course?.role_competency || '-' }}
                      </span>
                      <span class="badge-custom bg-info-soft text-info">
                        {{ course.role_competency_type || '-' }}
                      </span>
                    </div>
                    
                    <!-- Course Title -->
                    <h6 class="card-title font-weight-bold mb-2" style="font-size: 0.95rem; line-height: 1.3; min-height: 40px;">
                      {{ course.title }}
                    </h6>

                    <!-- Course Description -->
                    <p class="card-text text-muted course-description">
                      {{ course.description }}
                    </p>

                    <small v-if="hasQuotaInfo(course)" class="d-block text-muted">
                      {{ getEnrolledCount(course) }}/{{ getQuota(course) ?? '-' }} peserta · sisa {{ getRemainingQuota(course) ?? '-' }}
                    </small>
                  </div>
                  
                  <!-- Card Footer -->
                  <div class="card-footer bg-white border-top px-3 py-2">
                    <div class="d-flex justify-content-between align-items-center">
                      <!-- Left: Duration & Platform -->
                      <div class="d-flex gap-3">
                        <div class="d-flex align-items-center">
                          <i class="fe fe-clock text-muted me-1" style="font-size: 0.85rem;"></i>
                          <small class="text-muted" style="font-size: 0.75rem;">{{ course.hour }}h</small>
                        </div>
                        <div class="d-flex align-items-center">
                          <i class="fe fe-monitor text-muted me-1" style="font-size: 0.85rem;"></i>
                          <small class="text-muted" style="font-size: 0.75rem;">{{ course.platform }}</small>
                        </div>
                      </div>
                      
                      <!-- Right: Detail Button -->
                      <button class="btn btn-sm btn-outline-danger">
                        <i class="fe fe-eye" style="font-size: 0.8rem;"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pagination -->
            <div class="mt-4 pt-3 border-top">
              <div class="row align-items-center">
                <div class="col-md-4">
                  <div class="d-flex align-items-center">
                    <span class="text-muted small me-2">Show</span>
                    <select 
                      v-model="perPage" 
                      class="form-select form-select-sm" 
                      style="width: 70px;"
                      @change="onPerPageChange">
                      <option v-for="option in perPageOptions" :key="option" :value="option">{{ option }}</option>
                    </select>
                    <span class="text-muted small ms-2">entries</span>
                  </div>
                </div>
                <div class="col-md-4 text-center">
                  <small class="text-muted">
                    Showing {{ (currentPage - 1) * perPage + 1 }} to {{ Math.min(currentPage * perPage, totalItems) }} of {{ totalItems }} entries
                  </small>
                </div>
                <div class="col-md-4">
                  <nav>
                    <ul class="pagination pagination-sm justify-content-end mb-0">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                          <i class="fe fe-chevron-left"></i>
                        </button>
                      </li>
                      <li 
                        v-for="page in visiblePages" 
                        :key="page"
                        class="page-item" 
                        :class="{ active: currentPage === page, disabled: page === '...' }">
                        <button 
                          v-if="page === '...'" 
                          class="page-link" 
                          disabled>
                          ...
                        </button>
                        <button 
                          v-else
                          class="page-link" 
                          @click="changePage(page)">
                          {{ page }}
                        </button>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
                          <i class="fe fe-chevron-right"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <modal-batch-list 
      :selectedCourse="selectedCourse"
      :targetTrainingEventId="targetTrainingEventId"
      :idpPeriod="selectedPeriod"
      @batch-selected="handleBatchSelected"
    />
    
    <modal-participant-list 
      :selectedCourse="selectedCourse"
      :selectedBatch="selectedBatch"
      :batchIndex="selectedBatchIndex"
      @refresh-batch="refreshBatches"
    />

    <modal-course-filter
      :modal-id="filterModalId"
      :value="filters"
      :status-options="statusOptions"
      :approval-step-options="approvalStepOptions"
      :course-type-options="courseTypeOptions"
      @apply-filters="applyFilters"
      @reset-filters="resetFilters"
    />
  </div>
</template>

<script>
import logic from './mitra-enrollment.logic.js';
import ModalBatchList from './components/modal-batch-list.vue';
import ModalParticipantList from './components/modal-participant-list.vue';
import ModalCourseFilter from '@/components/mitra/ModalCourseFilter.vue';
import mitraCourseListFilter from '@/mixins/mitraCourseListFilter';

export default {
  ...logic,
  mixins: [mitraCourseListFilter],
  components: {
    ModalBatchList,
    ModalParticipantList,
    ModalCourseFilter
  },
};
</script>

<style scoped>
.me-2 {
  margin-right: 0.5rem;
}

.me-1 {
  margin-right: 0.25rem;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 1rem;
}

/* Status Card Styles */
.status-card {
  border-radius: 0.5rem;
  padding: 1.5rem 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.status-card:hover {
  transform: translateY(-2px);
}

.status-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-icon i {
  font-size: 1.5rem;
  color: white;
}

.status-card h3 {
  font-weight: bold;
  font-size: 2rem;
}

.status-card p {
  font-size: 0.875rem;
  font-weight: 500;
  opacity: 0.9;
}

.bg-warning {
  background-color: #f6c343 !important;
}

.bg-teal {
  background-color: #00d4b4 !important;
}

.bg-success {
  background-color: #00c9a7 !important;
}

.progress {
  background-color: #e9ecef;
  border-radius: 0.5rem;
  overflow: hidden;
}

.progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 0.6s ease;
}

/* Course Card Styles */
.course-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

/* Badge Styles */
.badge-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 50%;
  font-size: 0.7rem;
}

.badge-custom {
  padding: 0.25rem 0.5rem;
  font-size: 0.65rem;
  font-weight: 600;
  border-radius: 0.25rem;
}

/* Soft Badge Colors */
.bg-danger-soft {
  background-color: #fce4e4;
}

.text-danger {
  color: #e63757 !important;
}

.bg-warning-soft {
  background-color: #fef5e4;
}

.text-warning {
  color: #f6c343 !important;
}

.bg-info-soft {
  background-color: #e4f4f7;
}

.text-info {
  color: #39afd1 !important;
}

/* Pagination */
.pagination .page-link {
  color: #2c7be5;
  border: 1px solid #dee2e6;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  min-width: 36px;
  text-align: center;
}

.pagination .page-item.active .page-link {
  background-color: #e63757;
  border-color: #e63757;
  color: white;
}

.pagination .page-item.disabled .page-link {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: transparent;
}

.pagination .page-link:hover:not(.disabled) {
  background-color: #f8f9fa;
}

/* Course Description */
.course-description {
  font-size: 0.8rem;
  line-height: 1.4;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
